import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element }) => {
    const isAuthenticated = !!localStorage.getItem("accessToken");

    return isAuthenticated ? element : <Navigate replace to="/retail/login" />;
};

export default PrivateRoute;